import { styled } from '@linaria/react';
import { Flex } from '@vio/atlas/helpers/Flex';
export const Container = /*#__PURE__*/styled('section')({
  name: "Container",
  class: "c94qmmk",
  propsAsIs: false
});
const _exp4 = /*#__PURE__*/() => Flex.Column;
export const InfoWrapper = /*#__PURE__*/styled(_exp4())({
  name: "InfoWrapper",
  class: "ieg5xn4",
  propsAsIs: true
});
export const HotelName = /*#__PURE__*/styled('div')({
  name: "HotelName",
  class: "h1a4d3mm",
  propsAsIs: false
});
const _exp7 = /*#__PURE__*/() => Flex.Column;
export const NightlyOrTotalPriceWrapper = /*#__PURE__*/styled(_exp7())({
  name: "NightlyOrTotalPriceWrapper",
  class: "n5ewfi8",
  propsAsIs: true
});
export const TotalPriceMessage = /*#__PURE__*/styled('span')({
  name: "TotalPriceMessage",
  class: "tu88hej",
  propsAsIs: false
});
export const ReviewRatingWrapper = /*#__PURE__*/styled('div')({
  name: "ReviewRatingWrapper",
  class: "r1xjp2u3",
  propsAsIs: false
});
export const ImageContainer = /*#__PURE__*/styled('div')({
  name: "ImageContainer",
  class: "i5k1xc0",
  propsAsIs: false
});
export const PlaceholderImageElement = /*#__PURE__*/styled('img')({
  name: "PlaceholderImageElement",
  class: "plyy60p",
  propsAsIs: false
});

require("./styles.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.ts");